import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { resolveHeaderApiError, type HeaderApiError } from './headerApiError';

export interface Region {
  id: number;
  name: string;
  type: 'all' | 'city' | 'district' | 'street';
}

interface RegionsResponse {
  regions: Region[];
  current_region_id: number;
}

// API функции
async function fetchRegions(): Promise<RegionsResponse> {
  const { data } = await apiClient.get<RegionsResponse>('/regions');
  return data;
}

async function changeRegion(regionId: number): Promise<void> {
  await apiClient.put('/user/region', { region_id: regionId });
}

export function useRegions() {
  const queryClient = useQueryClient();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['regions'],
    queryFn: fetchRegions,
    staleTime: 300000, // 5 минут
    retry: false,
  });

  const headerError: HeaderApiError | null = resolveHeaderApiError(error);

  const changeRegionMutation = useMutation({
    mutationFn: changeRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] });
      // Обновить данные, зависящие от региона
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['devices'] });
    },
  });

  return {
    regions: data?.regions || [],
    currentRegionId: data?.current_region_id,
    isLoading,
    isError,
    error: headerError,
    refetch,
    changeRegion: (id: number) => changeRegionMutation.mutate(id),
  };
}

